import { Box, Button, CircularProgress, Container, Paper, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import LoginService from '../../services/LoginService';
import { useNavigate } from 'react-router';



const Login: React.FC = () => {
  const [username,setUsername] = useState('');
  const [password,setPassword] = useState('')
  const [loading, setLoading] = useState(false);
  const [error,setError] = useState('')
  const navigate = useNavigate();

  useEffect(() => {
    console.log(process.env.REACT_APP_API_URL);
  }, []);
  const handleLogin = () =>{
    setLoading(true)
    setError('')
    let loginService = new LoginService();
    loginService.logar(username,password).then((response) =>{
      localStorage.setItem("token", response.data['token']);
      navigate("/management")
    }).catch(error =>{
      setLoading(false)
      setError("Nome de usuário ou senha inválidos");
    })
  }
  return (
    <Container component="main"
            maxWidth="xs"
            sx={{
              height: '100vh', // 100% da altura da página
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
  }}>
      <Paper
        elevation={6}
        sx={{
          padding: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%', // Garante que o Paper ocupe a largura total possível
          maxWidth: 400, // Define um limite máximo de largura para o Paper
        }}
      >
        <Typography component="h1" variant="h5">
          Login
        </Typography>
        {error && (
          <Typography color="error" variant="body2" sx={{ marginTop: 1 }}>
            {error}
          </Typography>
        )}

        <Box component="form" sx={{ width: '100%', marginTop: 2 }} noValidate>
          <TextField
            label="Nome de usuário"
            fullWidth
            variant="outlined"
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            label="Senha"
            type="password"
            fullWidth
            variant="outlined"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleLogin}
            disabled={loading}
            sx={{ marginTop: 2 }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Entrar'}
          </Button>
        </Box>
      </Paper>
    </Container>
  )
}
export default Login;